import {
    ORFF_HERO_API_BASE_URL,
	LEAP_API_BASE_URL
} from 'assets/configurations/envConfigs';

export default [
    //Leap oauth
    {
        'name': 'oauth2_token',
        'url': () => 'oauth2/token',
        'baseUrl': LEAP_API_BASE_URL,
    },
    {
        'name': 'oauth2_authorization',
        'baseUrl': LEAP_API_BASE_URL,
        'url': clientCredentials => (
            `oauth2/authorization?response_type=code&client_id=${clientCredentials['client_id']}&redirect_uri=${clientCredentials['redirect_uri']}&scope=${clientCredentials['scope']}`
        )
    },
    {
        'name': 'oauth2_discover',
        'baseUrl': LEAP_API_BASE_URL,
        'url': () => `oauth2/discover`
    },
    {
        'name': 'oauth2_logout',
        'baseUrl': LEAP_API_BASE_URL,
        'url': ({ idToken, state, redirect }) => `oauth2/logout?id_token_hint=${idToken}&state=${state}&post_logout_redirect=${redirect}`
    },

    //USER
    {
        'name': 'me',
        'baseUrl': LEAP_API_BASE_URL,
        'url': () => 'integrations/leyaeducacao/me'
    },

    //DRM
    {
        'name': 'drm_check',
        'baseUrl': LEAP_API_BASE_URL,
        'url': () => 'drm/licensing_rights/check'
    },

    //ORFF_HERO
    {
        'name': 'set_user',
        'baseUrl': ORFF_HERO_API_BASE_URL,
        'url': ({ gameId, userId }) => `userdata/${gameId}/${userId}`
    },
    {
        'name': 'user_score',
        'baseUrl': ORFF_HERO_API_BASE_URL,
        'url': ({ gameId, userId }) => `userdata/${gameId}/${userId}/score`
    },
    {
        'name': 'user_battles',
        'baseUrl': ORFF_HERO_API_BASE_URL,
        'url': ({ gameId, userId }) => `userdata/${gameId}/${userId}/battles`
    },
    {
        'name': 'user_settings',
        'baseUrl': ORFF_HERO_API_BASE_URL,
        'url': ({ gameId, userId }) => `userdata/${gameId}/${userId}/settings`
    },
    {
        'name': 'game_events',
        'baseUrl': ORFF_HERO_API_BASE_URL,
        'url': ({ gameId }) => `events/${gameId}`
    }
];